import { render, staticRenderFns } from "./ProjectAbbreviationWidget.vue?vue&type=template&id=03336769&"
import script from "./ProjectAbbreviationWidget.vue?vue&type=script&lang=ts&"
export * from "./ProjectAbbreviationWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports